import { useParams, useLocation } from 'react-router'
import { useEffect, useState } from 'react'
import MentorSettingsPageMainComponent, {
  EMR_SETTINGS_SECTIONS,
} from 'src/mentor/components/MentorSettingsPage/MentorSettingsPageMainComponent'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import { getMinimalMentorData } from 'src/supportPortal/views/therapists/util'
import { LinearProgress } from '@mui/material'

export default function SupportDoctorSettings() {
  const { mentorSlug } = useParams()
  const location = useLocation()
  
  // Determine if this is a doctor or therapist route
  const isTherapistRoute = location.pathname.includes('/practitioner-management/therapists/')
  const apiEndpoint = isTherapistRoute 
    ? '/api/secure/cc/support/therapists/by-slug'
    : '/api/secure/cc/support/doctor/by-slug'
  const practitionerType = isTherapistRoute ? 'Therapist' : 'Doctor'

  const [currentTherapist, setCurrentTherapist] = useState()
  const [loadingTherapistData, setLoadingTherapistData] = useState(false)
  async function getSelectedTherapist() {
    setLoadingTherapistData(true)
    const resp = await getMinimalMentorData(
      mentorSlug,
      true,
      apiEndpoint,
    )
    setCurrentTherapist(resp)
    setLoadingTherapistData(false)
  }

  useEffect(() => {
    getSelectedTherapist()
  }, [])

  return (
    <>
      <SupportHeader
        heading={`${loadingTherapistData ? '--' : currentTherapist?.name || practitionerType}'s Settings`}
      />
      {loadingTherapistData && <LinearProgress />}
      {!loadingTherapistData && (
        <MentorSettingsPageMainComponent
          hideBackButton
          practitionerId={currentTherapist?.id}
          mentorProfileData={currentTherapist}
          excludeSections={[
            EMR_SETTINGS_SECTIONS.updateLocalData.id,
            EMR_SETTINGS_SECTIONS.debug.id,
          ]}
          defaultSelectedSection={EMR_SETTINGS_SECTIONS.emrSections.id}
          emrSectionsApiSignature={`/api/secure/cc/support/practitioner/emr-sections${currentTherapist?.slug ? `?practitioner-slug=${currentTherapist.slug}` : `?practitioner-id=${currentTherapist?.id}`}`}
          emrSettingsSaveApiSignature={`/api/secure/cc/support/practitioner/emr-sections/save${currentTherapist?.slug ? `?practitioner-slug=${currentTherapist.slug}` : `?practitioner-id=${currentTherapist?.id}`}`}
          prescriptionViewSettingsGetApiSignature={`/api/secure/cc/support/practitioner/settings/final-report-view${currentTherapist?.slug ? `?practitioner-slug=${currentTherapist.slug}` : `?practitioner-id=${currentTherapist?.id}`}`}
          prescriptionViewSettingsSaveApiSignature={`/api/secure/cc/support/practitioner/emr-settings/final-report-view/save${currentTherapist?.slug ? `?practitioner-slug=${currentTherapist.slug}` : `?practitioner-id=${currentTherapist?.id}`}`}
          appointmentCalendarSettingsGetApiSignature={`/api/secure/cc/support/practitioner/settings/appointment-calendar-settings${currentTherapist?.slug ? `?practitioner-slug=${currentTherapist.slug}` : `?practitioner-id=${currentTherapist?.id}`}`}
          appointmentCalendarSettingsSaveApiSignature={`/api/secure/cc/support/practitioner/settings/appointment-calendar-settings/save${currentTherapist?.slug ? `?practitioner-slug=${currentTherapist.slug}` : `?practitioner-id=${currentTherapist?.id}`}`}
          assessmentAccessGetApiSignature={`/api/secure/cc/support/practitioner/assessment-access${currentTherapist?.slug ? `?practitioner-slug=${currentTherapist.slug}` : `?practitioner-id=${currentTherapist?.id}`}`}
          assessmentAccessSaveApiSignature={`/api/secure/cc/support/practitioner/assessment-access/save${currentTherapist?.slug ? `?practitioner-slug=${currentTherapist.slug}` : `?practitioner-id=${currentTherapist?.id}`}`}
          forSupportPortal
        />
      )}
    </>
  )
}
